<template>
    <div :class="[{'dragging': dragging}]">
        <div class="text-center">
            <small v-if="blocks.length === 0">{{ $t('routines.no_blocks_created') }}</small>
        </div>
        <v-expansion-panels flat multiple accordion v-model="openFirst">
            <v-row>
                <draggable :disabled="readonly" v-model="blocks" style="width: 100%" handle=".handle">
                    <v-col cols="12" :lg="forceCols12 ? 12 : 6" v-for="(block,i) in blocks" :key="block.uid">
                        <v-expansion-panel>
                            <v-card>
                                <v-expansion-panel-header :class="['block-title kimsa-elevation', {'block-title-readonly': readonly}]">
                                    <v-row align="center">
                                        <v-col cols="12">
                                            <v-icon
                                                @mousedown="dragging = true" @mouseup="dragging = false"
                                                @touchstart="dragging = true" @touchend="dragging = false"
                                                v-if="!readonly" class="handle"
                                                @contextmenu.prevent="() => {return false}"
                                            >
                                                mdi-drag-vertical
                                            </v-icon>
                                            <div class="block-title-text">
                                                {{ $tc('common.blocks', 1) }} {{ i + 1 }}
                                            </div>
                                            <div class="float-right block-exercises-quantity">
                                                <v-icon size="20" color="#000000">mdi-dumbbell</v-icon>
                                                {{ block.exercises.length }}

                                                <v-menu offset-y v-if="!readonly">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon small v-on="on">
                                                            <v-icon>mdi-dots-horizontal</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list dense>
                                                        <v-list-item dense link @click="duplicateBlock(block, i)">
                                                            <v-list-item-title>
                                                                {{ $t('common.duplicate') }}
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item dense link @click="deleteBlock(i)">
                                                            <v-list-item-title>
                                                                {{ $t('common.delete') }}
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>

                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div v-if="block.exercises.length > 0" class="mt-6"/>
                                    <v-card v-if="block.exercises.length === 0" flat color="transparent">
                                        <v-card-text class="text-center caption">
                                            {{ $t('exercises.no_exercises_set') }}
                                        </v-card-text>
                                    </v-card>
                                    <draggable v-else v-model="blocks[i].exercises" draggable=".draggable-item"
                                               handle=".handle-item" ghost-class="ghost">
                                        <div v-for="(exercise,j) in block.exercises" :key="exercise.uid"
                                             class="draggable-item kimsa-elevation block-exercises">

                                            <block-exercise-card
                                                :exercise="exercise"
                                                :readonly="readonly"
                                                :is-second-dialog="isSecondDialog"
                                                @click:exercise="onClickExercise($event)"
                                                @click:duplicate="duplicateExercise($event, j, i)"
                                                @click:change="changeExercise($event, j, i)"
                                                @click:delete="deleteExercise(i, j)"
                                                @click:rest="setRest(block, j)"
                                                @change:config="onConfigChange($event, i, j)"
                                            />

                                            <rest-card
                                                v-if="exercise.hasTime"
                                                :rest="exercise"
                                                :readonly="readonly"
                                                @click="setRest(block, j)"
                                                @click:delete="deleteRest(i, j)"
                                            />

                                        </div>
                                    </draggable>
                                    <v-row class="mt-0 px-3" v-if="!readonly">
                                        <v-col cols="12 text-right">
                                            <v-btn
                                                color="black"
                                                small fab
                                                dark depressed
                                                @click="showAddExercisesDialog(block, i)">
                                                <v-icon>mdi-dumbbell</v-icon>
                                                <v-icon size="12" style="position: absolute; top: -8px; right: 0;">mdi-plus</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-card>
                        </v-expansion-panel>
                    </v-col>
                    <v-col cols="12" class="text-right pb-0" v-if="!readonly">
                        <v-btn
                            color="black"
                            small fab
                            dark depressed
                            @click="addBlock">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                </draggable>
            </v-row>
        </v-expansion-panels>

        <rest-dialog ref="setRestDialog" @save="onRestSave"/>

        <add-exercises-dialog
            ref="addExerciseDialog"
            @close="onAddExercisesClose"
            :block="activeBlock"
            :title="`${$tc('common.blocks',1)} ${activeBlockNumber+1}`"
            :one-exercise="oneExercise"
            :default-filter="defaultFilter"
            @change="addExercises"/>

    </div>
</template>

<script>

import AddExercisesDialog from '@/components/coach/routines/AddExercisesDialog'
import draggable from 'vuedraggable'
import {getMergedBlocks} from "@/utils/Exercises";
import RestDialog from "@/components/coach/routines/RestDialog";
import RestCard from "@/components/coach/routines/RestCard";
import BlockExerciseCard from "@/components/coach/routines/BlockExerciseCard";
import {randomString} from "@/utils/Common";

export default {
    props: {
        defaultBlocks: {
            type: Array,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        forceCols12: {
            type: Boolean,
            default: false
        },
        isSecondDialog: {
            type: Boolean,
            default: false
        },
    },
    components: {
        BlockExerciseCard,
        RestCard,
        RestDialog,
        AddExercisesDialog,
        draggable
    },
    data() {
        return {
            dragging: false,
            showAddBtn: false,
            blocks: [{exercises: []}],
            activeBlock: null,
            activeExerciseIndex: null,
            activeBlockNumber: 0,
            oneExercise: false,
            defaultFilter: null,
            exerciseIndex: null,
            openFirst: [0],
        }
    },
    mounted() {
        const vm = this
        vm.setDefaults()
        setTimeout(() => {
            this.openFirst = [0]
        }, 100)
    },
    methods: {
        onAddExercisesClose() {
            const vm = this
            vm.$emit('close:exercises-dialog')
        },
        async setDefaults() {
            const vm = this
            if (!vm.defaultBlocks || vm.defaultBlocks.length === 0) return
            vm.blocks = await getMergedBlocks(vm.defaultBlocks)
        },
        onConfigChange(config, blockIndex, exerciseIndex) {
            const vm = this
            let template = JSON.parse(JSON.stringify(vm.blocks[blockIndex].exercises[exerciseIndex]))
            template.config = config
            vm.blocks[blockIndex].exercises.splice(exerciseIndex, 1, template)
        },
        deleteExercise(blockIndex, exerciseIndex) {
            const vm = this
            vm.blocks[blockIndex].exercises.splice(exerciseIndex, 1)
        },
        deleteRest(blockIndex, exerciseIndex) {
            const vm = this
            vm.blocks[blockIndex].exercises[exerciseIndex].hasTime = false
            vm.blocks[blockIndex].exercises[exerciseIndex].time = ''
        },
        duplicateExercise(exercise, exerciseIndex, blockIndex) {
            const vm = this
            console.log('duplicating exercise:', exercise)
            vm.blocks[blockIndex].exercises.splice(exerciseIndex, 0, exercise)
        },
        changeExercise(exercise, exerciseIndex, blockIndex) {
            const vm = this
            console.log('change exercise:', exercise)
            vm.activeBlock = null
            vm.activeBlockNumber = blockIndex
            vm.exerciseIndex = exerciseIndex
            vm.oneExercise = true
            vm.defaultFilter = {categories: exercise.categories[0], types: exercise.types}
            vm.$refs.addExerciseDialog.show()
        },
        onRestSave(time) {
            const vm = this
            vm.activeBlock.exercises[vm.activeExerciseIndex].hasTime = true
            vm.activeBlock.exercises[vm.activeExerciseIndex].time = time
        },
        setRest(block, exerciseIndex = null) {
            const vm = this
            vm.activeBlock = block

            if (exerciseIndex >= 0) {
                vm.activeExerciseIndex = exerciseIndex
                let time = block.exercises[exerciseIndex]?.time || '00:00:00'
                vm.$refs.setRestDialog.showEdit(time)
            } else {
                vm.$refs.setRestDialog.show()
            }
        },
        addExercises(exercises) {
            const vm = this

            if (vm.oneExercise) return vm.blocks[vm.activeBlockNumber].exercises.splice(vm.exerciseIndex, 1, exercises[0])

            let newExercises = exercises.map(ex => {
                ex.uid = randomString()
                return ex
            })
            vm.activeBlock.exercises = [...vm.activeBlock.exercises, ...newExercises]
        },
        addBlock() {
            const vm = this
            vm.blocks.push({uid: randomString(), exercises: []})
            vm.openFirst.push(vm.blocks.length - 1)
            vm.scrollToEnd()
        },
        deleteBlock(index) {
            const vm = this
            vm.blocks.splice(index, 1)
        },
        duplicateBlock(block, index) {
            const vm = this
            let template = JSON.parse(JSON.stringify(block))
            template.uid = randomString()
            vm.blocks.splice(index, 0, template)
            vm.scrollToEnd()
        },
        showAddExercisesDialog(block, number) {
            const vm = this
            vm.activeBlock = block
            vm.activeBlockNumber = number
            vm.oneExercise = false
            vm.$refs.addExerciseDialog.show()
        },
        onClickExercise(exercise) {
            const vm = this
            return vm.$emit('click:exercise', exercise)
        },
        scrollToEnd() {
            const vm = this
            vm.$vuetify.goTo(document.body.scrollHeight)
        },
    },
    watch: {
        blocks() {
            this.$emit('change', this.blocks)
        },
    },
}
</script>

<style scoped>

.block-add-btn {
    /*margin-bottom: 50px;*/
    position: fixed;
    bottom: 30px;
    right: 10px;
}

.block-title {
    background-color: #CCFF99;
    padding: 5px 0;
    border: 1px solid rgba(51, 51, 51, 0.1);

}

.block-title-readonly {
    padding: 10px;
}

.block-title-text {
    font-size: 20px;
    color: #333333;
    text-transform: uppercase;
    font-weight: bold;
    display: inline;
}

.v-divider {
    margin-left: 40%;
    margin-right: 40%;
    color: #c5c5c5;
}

.ghost {
    width: 100%;
    overflow: hidden;
    background-color: #ccc;
}

.block-exercises-quantity {
    font-size: 20px;
    font-weight: bold;
}

.block-exercises {
    margin-bottom: 12px;
    border-radius: 8px;
}

>>> .v-expansion-panel-header__icon {
    transition: transform 0.3s;
}

>>> .v-expansion-panel--active .v-expansion-panel-header__icon {
    transform: rotate(180deg);
}

.v-expansion-panel::before {
    box-shadow: none;
}

</style>